import type { DeepPartial } from '@luna/utils-ts';

import type { NewPfmFeatures } from './type';

export const HU: DeepPartial<NewPfmFeatures> = {};
